import { EnglishUsLang } from './english_us';

export const localLanguages = [EnglishUsLang];
